import React from "react";
import { Link } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { useApp } from "@/context/AppContext";
import { localizeDict } from "@/lib/localText";

const L10N = {
  fr: { about: "À propos", contact: "Contact", faq: "FAQ", resources: "Ressources", discover: "Découvrir", churches: "Églises", events: "Événements", terms: "CGU", privacy: "Confidentialité", gdpr: "RGPD", child_safety: "Sécurité des enfants", delete_account: "Supprimer mon compte", tagline: "Le réseau chrétien qui rassemble" },
  en: { about: "About", contact: "Contact", faq: "FAQ", resources: "Resources", discover: "Discover", churches: "Churches", events: "Events", terms: "Terms", privacy: "Privacy", gdpr: "GDPR", child_safety: "Child safety", delete_account: "Delete my account", tagline: "The Christian network that gathers" },
  es: { about: "Acerca de", contact: "Contacto", faq: "FAQ", resources: "Recursos", discover: "Descubrir", churches: "Iglesias", events: "Eventos", terms: "Términos", privacy: "Privacidad", gdpr: "RGPD", child_safety: "Seguridad infantil", delete_account: "Eliminar mi cuenta", tagline: "La red cristiana que reúne" },
  pt: { about: "Sobre", contact: "Contacto", faq: "FAQ", resources: "Recursos", discover: "Descobrir", churches: "Igrejas", events: "Eventos", terms: "Termos", privacy: "Privacidade", gdpr: "RGPD", child_safety: "Segurança infantil", delete_account: "Excluir a minha conta", tagline: "A rede cristã que reúne" },
};

const LINKS = [
  ["about", "/a-propos"], ["contact", "/contact"], ["faq", "/faq"], ["resources", "/ressources"], ["discover", "/decouvrir"], ["churches", "/churches"], ["events", "/events"],
  ["terms", "/legal/terms"], ["privacy", "/legal/privacy"], ["gdpr", "/legal/gdpr"], ["child_safety", "/legal/child-safety"], ["delete_account", "/supprimer-mon-compte"],
];

// Pied de page global du site WEB (jamais dans l'app native) : liens éditoriaux + légaux sur chaque page
// publique, lisibles par les robots (maillage interne AdSense / SEO). « Ressources » n'apparaît que si le module CMS est activé.
export const SiteFooter = ({ className = "" }) => {
  const { lang, config } = useApp();
  if (Capacitor.isNativePlatform()) return null;
  const tr = localizeDict(L10N, lang, config?.translations, "footer");
  const links = LINKS.filter(([k]) => k !== "resources" || config?.settings?.features?.resources === true);
  return (
    <footer className={`max-w-2xl mx-auto px-4 pt-6 pb-8 text-xs ${className}`} style={{ color: "var(--yalola-text-muted)" }} data-testid="site-footer">
      <nav aria-label="Yalola" className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
        {links.map(([k, to], i) => (
          <React.Fragment key={k}>
            {i > 0 && <span aria-hidden>·</span>}
            <Link to={to} className="hover:underline" data-testid={`site-footer-${k}`}>{tr[k]}</Link>
          </React.Fragment>
        ))}
      </nav>
      <div className="text-center mt-2">© {new Date().getFullYear()} {config?.settings?.app_name || "Yalola"} — {tr.tagline}</div>
    </footer>
  );
};

export default SiteFooter;
